import Button from 'components/Button/index'
import RoutePath from 'components/RoutePath'
import Drawer from 'components/Drawer'
import DownArrowSolid from 'components/icons/DownArrowSolid'
import LeftArrow from 'components/icons/LeftArrow'
import DownlaodUpload from 'modules/Drives/DownloadAndUpload/index'
import BulkActionDrawer from 'modules/Drives/ViewDriveRole/BulkActionDrawer/index'
import Metrics, { roleMenu } from 'modules/Drives/ViewDriveRole/Header/Metrics'
import { ExternalDriveTable } from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ExternalAssesment/index.js'
import IndividualDriveTable from 'modules/Drives/ViewDriveRole/IndividualDriveTable/index'
import AtsExportIcon from 'components/icons/AtsExportIcon'
import {
  BulkUploadDiv,
  CandidatesSpan,
  DropDown,
  LeftSection,
  PaddedDiv,
  RoleNameDiv,
  RoleNameFlex,
  SectionName,
  SectionWrapper,
  StyledTab,
  TopEndFlex,
  TopHeader,
} from 'modules/Drives/ViewDriveRole/Style/style'
import ShortListDrawer from 'modules/Exp-Candidates/ViewDriveRole/IndividualDriveTable/ShortListPopUp'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import { getIdFormate, getZeroBeforeInt } from 'utils/getZeroBeforeInt'
import { EmptyElement } from '../../../components/UIComponents/CommonStyledDiv'
import { permittedSubEvents } from '../../../utils/permissionsValidation'
import ActionRoleDrawer from '../../../components/UIComponents/ActionRoleDrawer'
import { singlePdf, zipFile } from '../../../utils/downloadFile'
import SuccessModal from '../../../components/UIComponents/ActionRoleDrawer/SuccessModal'
import SuccessIcon from '../../../components/icons/SuccessIcon'
import EvaluationForm from 'modules/Drives/Components/EvaluationForm/index.js'
import { FooterFlex } from './Style/style'
import ExportTransfer from '../../../components/ExportTransfer'
import UploadInviteDrawer from 'modules/Exp-Candidates/DownloadAndUpload/UploadInviteDrawer/index'
import InvitedCandidatesTable from 'modules/Drives/ViewDriveRole/InvitedCandidatesTable/index'
import { getInviteCandidatesCount, getInviteCandidates } from 'modules/Exp-Candidates/actions'

const { TabPane } = StyledTab

// Default candidate-filter panel selections. Lifted to this parent so the
// selections survive IndividualDriveTable remounts on stage/round changes.
const DEFAULT_FILTER_VALUES = {
  selectedRound: [],
  selectedStatus: [],
  selectedDegrees: [],
  selectedDepartments: [],
  selectedSpecializations: [],
  selectedYears: [],
  selectedSkills: [],
  selectedColleges: [],
  selectedCollegeStates: [],
  selectedCollegeCities: [],
  selectedAge: {
    from: null,
    to: null,
    fromMonths: null,
    toMonths: null,
    strict: false,
  },
  selectedQuickAge: {
    from: null,
    to: null,
  },
  selectedGender: [],
  selectedScoreFilterType: '',
  selectedCurrentArrearFilterType: '',
  selectedPastArrearFilterType: '',
  selectScories: [],
  selectedCurrentArrearCount: null,
  selectedPastArrearCount: null,
  selectedPermanentState: [],
  selectedPermanentCity: [],
  selectedCurrentState: [],
  selectedCurrentCity: [],
  selectedPreferredLocation: [],
  selectedFunction: [],
  selectedRole: [],
  selectedDurationYear: [],
  selectedDurationMonth: [],
  selectedRoundScore: [],
  selectedQualifyingQuestions: [],
  selectedCustomQuestions: [],
  selectedAppliedDateRange: [],
  selectedAssessmentStatus: [],
  selectedRoundMode: true,
  includeArrears: false,
}

const ViewIndividualDrive = ({
  driveRolesMetrics,
  getDriveRoleMetrics,
  getDriveRoleCandidatesList,
  getRoleMetrics,
  rolesMetrics,
  getDegreeAndDepartMent,
  degreeList,
  getIndidualDriveData,
  driveData,
  createInterview,
  driveInterViewerList,
  getDriveInterviewerList,
  getcollegeList,
  collegeList,
  getCandidateDetails,
  candidateDetails,
  getSingleCandidateInterviewDetails,
  candidateInterviewDetails,
  getGroupDiscussionList,
  getGroupCandidateList,
  groupList,
  groupCandidateList,
  updateInterviewStatus,
  getCities,
  cityList,
  releaseOfferAPI,
  getSingleRoleData,
  singleRoleData,
  fileUpload,
  getCandidateScoreList,
  postShortlistCandidates,
  getTopicsList,
  postPassingScore,
  getNewDriveFreshersList,
  newFreshersListData,
  getNewDriveStatus,
  newDriveStatusData,
  getNewDriveScore,
  newDriveScoreData,
  getNewIndividualDriveStatus,
  getPanelList,
  resumeBulkDownload,
  getRounds,
  getStatus,
  getYear,
  getCollegeListForFilter,
  getSkillForFilter,
  getQuestionForFilter,
  getCustomQuestionFilterOptions,
  getWorkExperienceForFilter,
  getLocationForFilter,
  getDegreeForFilter,
  updateNewRound,
  addNewRound,
  roundData,
  updatedRoundData,
  downloadTemplate,
  uploadShorlistResult,
  getExportFiledData,
  atsExportCandidate,
  getConflictCandidates,
  updateResolveConflictCandidates
}) => {
  const removeParams = () => {
    const url = new URL(window.location)
    url.searchParams.delete('schedule')
    window.history.pushState({}, '', url)
  }
  const params = useParams()
  const navigate = useNavigate()
  const tableRef = useRef(null)
  let [searchParams, setSearchParams] = useSearchParams()
  const stageParams = searchParams.get('stage')
 let stage = stageParams === null ? 'all_candidates' : stageParams
  const checkType = searchParams.get('type')
  const isUpload = searchParams.get('isUpload')
  const assessment = searchParams.get('assessment')
  const assessmentId = searchParams.get('assessmentId')
  const isBack = searchParams.get('isBack')
  const roundId = searchParams.get('roundId')
  const [selectedRound, setSelectedRound] = useState(stage)
  const [popSelectedRound,setPopSelectedRound] = useState('')
  const [panelValue, setPanelValue] = useState('all')
  const [topicsPayload, setTopicsPayload] = useState({})
  const [currentScorePage, setCurrentScorePage] = useState(0)
  const [selectedRoundType, setSelectedRoundType] = useState('')
  const [currentTab, setCurrentTab] = useState(stage === 'all_candidates' || stage === null ? 'APPLIED_TAB' : 'ACTIVE')
  const [createSlotDrawer, setCreateSlotDrawer] = useState(false)
  const [currentScoreTab, setCurrentScoreTab] = useState(
    'INVITED,STARTED,COMPLETED,ABSENT'
  )
  const [type, setType] = useState({ type: '', assessmentType: '', round: '' })
  const [bulkAction, setBulkAction] = useState(false)
  const [scheduleDrawer, setScheduleDrawer] = useState(false)
  const [releaseOffer, setReleaseOffer] = useState(false)
  const [selectedCandidate, setSelectedCandidate] = useState([])
  const [selectedIds, setSelectedIds] = useState('')
  const [selectedCandidateId, setSelectedCandidateId] = useState([])
  const [candidateScoreDeatils, setCandidateScoreDeatils] = useState({})
  const [searchScoreValue, setSearchScoreValue] = useState('')
  const [sortScoreBy, setSortScoreBy] = useState('')
  const [shortListDrawer, setShortListDrawer] = useState(false)
  const [searchName, setSearchName] = useState('')
  const [isLoading, setISLoading] = useState(false)
  const [candidateDeatils, setCandidateDeatils] = useState({})
  const [currentPage, setCurrentPage] = useState(0)
  const [status, setStatus] = useState(stage === 'all_candidates' || stage === null ? 'APPLIED_TAB' : 'ACTIVE')
  const [searchValue, setSearchValue] = useState('')
  const [showSuccessPopup, setShowSuccessPopup] = useState(false)
  const [sortedItems, setSortedItems] = useState([])
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [debouncedSearchValue, setDebouncedSearchValue] = useState(
    () => searchValue
  )
  const [isEditingForm, setIsEditingForm] = useState(false)
  const [scheduleTrue, setScheduleTrue] = useState(false)
  const [sortBy, setSortBy] = useState('')
  const [tabNames, setTabNames] = useState([])
  const [filter, setFilter] = useState([])
  const [count, setCount] = useState(0)
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [candidateRating, setCandidateRating] = useState([])
  const [interviewRound, setInterviewRound] = useState([])
  const [college, setCollege] = useState([])
  const [collegeSearch, setCollegeSearch] = useState('')
  const [checkedKeys, setCheckedKeys] = useState([])
  const [checkedIds, setCheckedIds] = useState([])
  const [filterStatus, setFilterStatus] = useState('ACTIVE')
  const [scoreStatus, setScoreStatus] = useState(
    'INVITED,STARTED,COMPLETED,ABSENT'
  )
  const [saveEnable, setSaveEnable] = useState(false)
  const [scorePayload, setScorePayload] = useState({})
  const [candidateInfoData, setCandidateInfoData] = useState({})
  const [panelData, setPanelData] = useState('')
  const [lastPanelId, setLastPanelId] = useState(0)
  const [isAllSelected, setIsAllSelected] = useState(false)
  const [tabValue, setTabValue] = useState('ACTIVE')
  const [wholeSelect, setWholeSelect] = useState(false)
  const [selectedFilterValue, setSelectedFilterValue] = useState({})
  // Candidate-filter panel selections are lifted here (instead of inside
  // IndividualDriveTable) so they persist across stage/round changes — the
  // table component remounts when switching All Candidates <-> a round, which
  // would otherwise wipe the selected filters even though the applied filter
  // (selectedFilterValue) and the filtered list still persist.
  const [filterValues, setFilterValues] = useState(DEFAULT_FILTER_VALUES)
  const [bulkDownload, setBulkDownload] = useState(false)
  const [studentListId, setStudentListId] = useState([])
  const [actionDrawer, setActionDrawer] = useState(false)
  const [openDrawer, setOpenDrawer] = useState(false)
  const [save, setSave] = useState(false)
  const [formSave, setFormSave] = useState(false)
  const [selectedKeys, setSelectedKeys] = useState([])
  const [exportType, setExportType] = useState('')
  const [exportData, setExportData] = useState([])
  const [exportLoading, setExportLoading] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [transfer, setTransfer] = useState(false)
  const [targetKeys, setTargetKeys] = useState([])
  const [conflictData, setConflictData] = useState([])
  const isAllCandidates = !stage || stage === 'all_candidates';
  const [invitedCount, setInvitedCount] = useState(0)
  const [inviteDrawerOpen, setInviteDrawerOpen] = useState(false)
  const [inviteTableRefresh, setInviteTableRefresh] = useState(0)
  const dispatch = useDispatch()

  useEffect(() => {
    if (params?.roleId) {
      dispatch(getInviteCandidatesCount(params?.roleId)).then(res => {
        if (res?.status === 200) {
          setInvitedCount(res?.data?.data?.count || 0)
        }
      })
    }
  }, [params?.roleId])

  useEffect(() => {
    if (stage === 'all_candidates' || stage === null) {
      setCurrentTab('APPLIED_TAB')
      setStatus('APPLIED_TAB')
      setTabValue('APPLIED_TAB')
    }
  }, [stage])

  function isObject(value) {
    return typeof value === 'object' && value !== null
  }
  const [roundValues, setRoundValues] = useState({
    roundName: '',
    roundNameError: '',
    interviewType: '',
    interviewTypeError: '',
    assessmentType: '',
    assessmentTypeError: '',
    roundDescription: '',
    roundDescriptionError: '',
    faceToFaceType: '',
    faceToFaceTypeError: '',
    startDateError: '',
    endDateError: '',
    startDate: null,
    endDate: null,
    id: '',
    prePlacement: false,
  })
  const onTabChange = key => {
    setStatus(key)
    setTabValue(key)
    setCurrentTab(key)
    setSelectedCandidateId([])
    setSelectedCandidate([])
    setIsAllSelected(false)
    setSearchValue('')
    setSearchScoreValue('')
    setCurrentPage(0)
    setSelectedIds([])
    setPanelValue('all')
    setPanelData('')
    setScorePayload({})
    setCandidateRating({})
    setSelectedFilterValue({})
  }
  const [nextRoundData, setNextRoundData] = useState([])

  const nextRoundFunction = async roundList => {
    const allRounds = roundList || rounds || []
    const currentStage = stage // e.g., "GD"

    const currentIndex = allRounds.findIndex(
      r => r.value.toLowerCase() === currentStage?.toLowerCase()
    )

    let nextRounds =
      currentIndex !== -1 ? allRounds.slice(currentIndex + 1) : allRounds

    const offerExists = allRounds.some(r => r.value.toLowerCase() === 'offer')

    if (!offerExists) {
      nextRounds.push({ name: 'Intent to Offer', value: 'offer' })
    }
    setNextRoundData(nextRounds)
    setPopSelectedRound(nextRounds[0].value)
  }
  
  const [rounds, setRounds] = useState([])

  const onScoreTabChange = key => {
    setScoreStatus(key)
    setFilterStatus('')
    setCurrentScoreTab(key)
    setTabNames(key)
    setISLoading(true)
    setCandidateScoreDeatils({})
    setSearchScoreValue('')
    setCurrentScorePage(0)
    setFilter([])
    setSelectedIds([])
    setCount(count + 1)
    setSelectedIds([])
    setPanelValue('all')
    setPanelData('')
    setSelectedCandidateId([])
    setIsMenuOpen(false)
  }

  const onRoleChange = roleId => {
    navigate(`/drives/${params?.driveId}/role/${roleId}`)
  }

  const getCandidateList = async (filterPayload, page = 0) => {
    try {
      if (!bulkDownload) {
        setISLoading(true)
      }

      let payload = {
        driveId: params?.driveId,
        roleId: params?.roleId,
        currentPage: searchValue ? 0 : page,
        searchValue: searchValue?.trim(),
        sortBy,
        status,
        stage,
        candidateRating,
        checkedIds,
        college,
        rolesMetrics,
        scorePayload,
        panelValue,
        isActive: tabValue == 'ACTIVE',
      }

      if (bulkDownload) {
        payload.bulkDownload = true
      }

      if (filterPayload) {
        // Check if preferredLocationIds exists and has values but doesn't include "anywhere"
        if (filterPayload?.preferredLocationIds?.length > 0 && 
            !filterPayload?.preferredLocationIds.includes("anywhere")) {
          // Add "anywhere" to the beginning of the array
          filterPayload.preferredLocationIds = ["anywhere", ...filterPayload.preferredLocationIds];
        }
        payload.filterPayload = filterPayload
      }
      let response = await getNewDriveFreshersList(payload)

      if (response?.status >= 200 && response?.status <= 300) {
        if (bulkDownload) {
          setActionDrawer(true)
          setStudentListId(response?.data?.data?.studentIds || [])
          setBulkDownload(false)
          getRoleMetrics(params?.driveId, params?.roleId)
        } else {

          const data = response?.data?.data || {}
          if (stage === 'offer') {
            data.notDisabledCount = data?.count ?? 0
          }
          setCandidateDeatils(data)
          getNewDriveStatus(params?.driveId, params?.roleId, stage)
          getNewDriveScore(params?.driveId, params?.roleId, stage)
          setSelectedCandidateId([])
          setCurrentPage(response?.data?.data?.page || page || 0)
        }
      }
    } catch (err) {
      console.error('Error in getCandidateList', err)
    } finally {
      setTimeout(() => {
        setISLoading(false)
      }, 500)
    }
  }

  useEffect(() => {
    if (bulkDownload === true) {
      getCandidateList()
    }
  }, [bulkDownload])

  const fetchBulkStudentIds = async (filterPayloadOverride) => {
    try {
      const payload = {
        driveId: params?.driveId,
        roleId: params?.roleId,
        currentPage: 0,
        searchValue: searchValue?.trim(),
        sortBy,
        status,
        stage,
        candidateRating,
        checkedIds,
        college,
        rolesMetrics,
        scorePayload,
        panelValue,
        isActive: tabValue == 'ACTIVE',
        bulkDownload: true,
      }
      const effectiveFilter = filterPayloadOverride ?? selectedFilterValue
      if (effectiveFilter && Object.keys(effectiveFilter).length > 0) {
        payload.filterPayload = effectiveFilter
      }
      const response = await getNewDriveFreshersList(payload)
      return (response?.data?.data?.studentIds || []).flat()
    } catch (e) {
      return []
    }
  }

  const getCandidateScore = async () => {
    const currentPage = currentScorePage
    const searchValue = searchScoreValue
    const sortBy = sortScoreBy
    const status = scoreStatus
    setISLoading(true)
    setCandidateScoreDeatils({})

    let response = await getCandidateScoreList({
      driveId: params?.driveId,
      roleId: params?.roleId,
      currentPage,
      searchValue,
      sortBy,
      status,
      stage,
      candidateRating,
      checkedIds,
      college,
      rolesMetrics,
      topicsPayload,
      filter,
    })
    if (response?.status >= 200 && response?.status <= 300) {
      setCandidateScoreDeatils(response?.data?.data || [])
      setSelectedCandidateId([])
      setISLoading(false)
    } else {
      setISLoading(false)
    }
  }

  useEffect(() => {
    if (JSON.parse(isUpload)) {
      getCandidateScore()
    }
  }, [
    isUpload,
    params,
    currentScorePage,
    searchScoreValue,
    sortScoreBy,
    scoreStatus,
    stage,
    rolesMetrics,
    topicsPayload,
    filter,
  ])

  const getGDList = () => {
    getGroupDiscussionList(
      params?.roleId,
      params?.driveId,
      stage,
      status === 'ACTIVE' ? 'ACTIVE' : status,
      currentPage
    )
  }
  const onDrawerOpen = () => {
    setShortListDrawer(true)
  }
  const handleTransferClick = async isOpen => {
    try {
      if (isOpen) {
        let fieldDatas = await getExportFiledData(
          params.roleId,
          corporateData.id,
          '',
          ''
        )
        if (singleRoleData?.applicationFormTemplate) {
          fieldDatas = ['Form Responses', ...fieldDatas]
        }
        fieldDatas = fieldDatas.map((item, index) => {
          return {
            key: index,
            title: item,
          }
        })
        setExportData(fieldDatas)
      } else {
        setExportData([])
      }
      setSelectedKeys([])
      setExportType('')
      setTargetKeys([])
      setTransfer(isOpen)
    } catch (error) {}
  }
  const onShortlistButtonClick = async () => {
    const result = selectedIds?.map(studentId => ({ studentId }))

    let response = await postShortlistCandidates(assessmentId, result)
    if (response?.status >= 200 && response?.status <= 300) {
      SuccessMessage('Shortlisted Successfully')
      setISLoading(false)
      getCandidateScore()
      getDriveRoleMetrics(params?.driveId)
      getRoleMetrics(params?.driveId, params?.roleId)
      setSelectedIds('')
      setSelectedCandidateId([])
    } else {
      setISLoading(false)
      ErrorMessage(response?.response?.data?.message)
    }
  }

  // Reset the candidate filters when the ROLE changes. Filters persist across
  // stage/round changes (so navigating away and back keeps them), but a
  // different role must start clean. This route reuses the same component
  // across roles, so the reset has to be explicit.
  const isFirstRoleRender = useRef(true)
  useEffect(() => {
    if (isFirstRoleRender.current) {
      isFirstRoleRender.current = false
      return
    }
    setFilterValues(DEFAULT_FILTER_VALUES)
    setSelectedFilterValue({})
  }, [params?.roleId])

  const prevStageRef = useRef(stage)
  useEffect(() => {
    // Preserve the currently-applied filters when re-fetching on sort/status/
    // search/tab changes (calling getCandidateList() with no argument drops
    // payload.filterPayload, which silently removed the filter on sort).
    //
    // BUT clear the filters when the STAGE/round changes: moving to the next
    // stage/round should start clean — reset both the panel selections
    // (filterValues) and the applied payload (selectedFilterValue), and fetch
    // the unfiltered list.
    const stageChanged = prevStageRef.current !== stage
    prevStageRef.current = stage

    let currentFilterPayload = selectedFilterValue || {}
    if (stageChanged) {
      currentFilterPayload = {}
      setFilterValues(DEFAULT_FILTER_VALUES)
      if (Object.keys(selectedFilterValue || {}).length > 0) {
        setSelectedFilterValue({})
      }
    }
    getCandidateList(currentFilterPayload)
  }, [
    stage,
    searchValue,
    sortBy,
    status,
    panelValue,
    tabValue,
  ])

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearchValue(searchValue)
    }, 1000)
    return () => {
      clearTimeout(timeout)
    }
  }, [searchValue])
  const fetchRounds = async () => {
    const roundList = await getRounds(params?.roleId, stage)
    setRounds(roundList)
    nextRoundFunction(roundList)
  }
  useEffect(() => {
    if (params?.roleId) {
      fetchRounds()
    }
    getDriveRoleMetrics(params?.driveId)
    getRoleMetrics(params?.driveId, params?.roleId)
    getDegreeAndDepartMent(params?.roleId)
    getSingleRoleData(0, params?.roleId)
  }, [params?.driveId, params?.roleId,params?.stage])
  useEffect(() => {
    let candidateStage =
      stage === 'all_candidates' ? candidateInfoData?.stage : stage
    const selectedRoundObj = rolesMetrics[0]?.rounds.filter(round => {
      if (round?.roundName === candidateStage) return round
    })[0]
    setSelectedRoundType(selectedRoundObj)
    if (selectedRoundObj?.type === 'GROUP' && status !== 'SHORTLISTED')
      getGDList()
  }, [
    params?.driveId,
    params?.roleId,
    stage,
    rolesMetrics,
    params,
    currentPage,
    candidateInfoData,
    status,
    panelValue,
  ])

  useEffect(() => {
    getcollegeList(params?.driveId, params?.roleId, collegeSearch)
  }, [params?.driveId, params?.roleId, collegeSearch])

  useEffect(() => {
    setSelectedRound(stage || 'all_candidates')
    setInterviewRound([stage || 'all_candidates'])
  }, [stage])

 

  const paths = [
    {
      from: 'Roles',
      path: '/rolePage',
    },
    {
      from: 'View Role',
      path: `/jobRoles/jobPreview/${params?.roleId}`,
    },
  ]

  const scoreTabList = [
    {
      tabName: 'Total Candidates',
      count: candidateScoreDeatils?.totalCandidateCount || 0,
      key: 'INVITED,STARTED,COMPLETED,ABSENT',
    },
    {
      tabName: 'Invited',
      count: candidateScoreDeatils?.invitedCount || 0,
      key: 'INVITED',
    },
    {
      tabName: 'Assessment Started',
      count: candidateScoreDeatils?.startedCount || 0,
      key: 'STARTED',
    },
    {
      tabName: 'Assessment Completed',
      count: candidateScoreDeatils?.completedCount || 0,
      key: 'COMPLETED',
    },
    {
      tabName: 'Absent',
      count: candidateScoreDeatils?.absentCount || 0,
      key: 'ABSENT',
    },
  ]

  const fullTabList = [
    {
      tabName: 'Active',
      count: candidateDeatils?.activeCount,
      key: 'ACTIVE',
    },
    {
      tabName: 'Schedule',
      count: candidateDeatils?.scheduleCount,
      key: 'SCHEDULED,TO_BE_SCHEDULED',
    },
    ...(checkType !== 'ASSESMENT'
      ? [
          {
            tabName: 'Reschedule',
            count: candidateDeatils?.rescheduleCount,
            key: 'RESCHEDULED,RESCHEDULE',
          },
        ]
      : []),
    {
      tabName: 'Held to compare',
      count: candidateDeatils?.heldtoCompareCount,
      key: 'HELD_TO_COMPARE',
    },
    {
      tabName: 'Rejected',
      count: candidateDeatils?.rejectedCount,
      key: 'REJECTED',
    },
    ...(checkType !== 'ASSESMENT'
      ? [
          {
            tabName: 'Absent',
            count: candidateDeatils?.absentCount,
            key: 'ABSENT',
          },
        ]
      : []),
  ];
  
  const tabList =
    checkType === 'CV_SCREENING'
      ? fullTabList.filter(tab => ['Active', 'Rejected'].includes(tab.tabName))
      : fullTabList;
  

  const tabDeatils =
    stage === 'offer'
      ? [
          {
            tabName: 'Active',
            count: candidateDeatils?.activeOfferCount,
            key: 'ACTIVE',
            tabKey: 'tab_panel_key',
          },
          {
            tabName: 'Released',
            count: candidateDeatils?.offerRleasedCount,
            key: 'RELEASED',
          },
          {
            tabName: 'Accepted',
            count: candidateDeatils?.offerAcceptedCount,
            key: 'ACCEPTED',
          },
          {
            tabName: 'Rejected',
            count: candidateDeatils?.offerRejectedCount,
            key: 'REJECTED',
          },
          {
            tabName: 'Joined',
            count:  candidateDeatils?.offerJoinedCount,
            key: 'JOINED',
          },
          {
            tabName: 'Left',
            count:  candidateDeatils?.offerLeftedCount,
            key: 'LEFTED',
          },
        ]
      : checkType === 'EXTERNAL_ASSESMENT'
      ? [
          {
            tabName: 'Active',
            count: candidateDeatils?.activeCount,
            key: 'ACTIVE',
          },
          {
            tabName: 'Schedule',
            count: candidateDeatils?.scheduleCount,
            key: 'SCHEDULED,TO_BE_SCHEDULED',
          },
          {
            tabName: 'Rejected',
            count: candidateDeatils?.rejectedCount,
            key: 'REJECTED',
          },
        ]
      : stage === 'all_candidates'
      ? [
          {
            tabName: 'Applied',
            count: candidateDeatils?.totalCount || rolesMetrics?.[0]?.candidateCount || 0,
            key: 'APPLIED_TAB',
          },
          {
            tabName: 'Invited',
            count: invitedCount,
            key: 'INVITED_TAB',
          },
        ]
      : tabList
      const getStageCount = () => {
        if (!rolesMetrics) return 0;
      
        if (stage === null || stage === "all_candidates") {
          return rolesMetrics[0]?.candidateCount || 0;
        }
      
        const matchingRound = rolesMetrics[0]?.rounds?.find(
          (r) => r.roundName === stage
        );
      
        return matchingRound?.count || 0;
      };
      
      // Disable export when there are no candidates to export: either the stage
      // itself is empty, or the active filter/search narrowed the list to zero.
      const hasCandidatesInView =
        (candidateDeatils?.count ?? 0) > 0 ||
        (candidateDeatils?.notDisabledCount ?? 0) > 0 ||
        (candidateDeatils?.totalCount ?? 0) > 0;
      const isDisabled = getStageCount() === 0 || !hasCandidatesInView;
  const onClickLink = (e, content) => {
    e.preventDefault()
    let data = rolesMetrics?.[0]?.rounds?.find(
      item => item.roundName === selectedRound
    )
    setSearchParams({
      ...searchParams,
      stage: data?.roundName,
      type: data?.type ? data?.type : 'all',
      assessment: data?.assesmentType ? data?.assesmentType : 'Test Gorilla',
      isUpload: isObject(data?.extAssmnts),
      assessmentId: data?.extAssmnts?.id,
      isBack: content !== 'score',
    })
  }

  const columns = [
    {
      dataIndex: 'title',
      title: 'Name',
    },
  ]

  useEffect(() => {
    tableRef.current.scrollIntoView({
      behavior: 'smooth',
    })
  }, [currentPage, currentScorePage])
  
  const { userData, corporateData } = useSelector(state => state.auth)
  const permission = useSelector(state => state?.auth?.permissions)

  const subEvents = permittedSubEvents(
    permission,
    'Evaluation Process - Fresher',
    'Drive Info'
  )

  const closePopup = () => {
    setShowSuccessPopup(false)
  }
  const handleApprove = async () => {
    setActionDrawer(false)
    setBulkDownload(false)
    setIsAllSelected(false)
    setWholeSelect(false)
    setSelectedCandidateId([])
    let payload = {
      email: userData.email,
      instName: corporateData.name,
      state: corporateData.state,
      city: corporateData.city,
      user: userData.first_name + ' ' + userData.last_name,
      studentIds: isAllSelected === true ? studentListId : [studentListId],
      roleId: params?.roleId,
    }
    if (payload.studentIds[0].length > 5) {
      setShowSuccessPopup(true)
    }
    const response = await resumeBulkDownload(payload)
    if (response?.data) {
      if (payload?.studentIds[0]?.length === 1) {
        const studentData = selectedCandidate[0].student
        const studentName = studentData?.firstName + ' ' + studentData?.lastName
        await singlePdf(response, studentName)
      } else if (payload?.studentIds[0]?.length <= 5) {
        await zipFile(response.data)
      }
    }
    setStudentListId([])
  }

  const handleClose = () => {
    setActionDrawer(false)
  }
  useEffect(() => {
    if (openDrawer) {
      setRoundValues({
        roundName: '',
        roundNameError: '',
        interviewType: '',
        interviewTypeError: '',
        assessmentType: '',
        assessmentTypeError: '',
        roundDescription: '',
        roundDescriptionError: '',
        faceToFaceType: '',
        faceToFaceTypeError: '',
        startDateError: '',
        endDateError: '',
        startDate: null,
        endDate: null,
        id: '',
        prePlacement: false,
      })
    }
  }, [openDrawer])
  const content = () => {
    return (
      <EvaluationForm
        updateNewRound={updateNewRound}
        addNewRound={addNewRound}
        roundData={roundData}
        updateRoundData={updatedRoundData}
        sortedItems={sortedItems}
        setSortedItems={setSortedItems}
        save={formSave}
        setSave={setFormSave}
        openDrawer={openDrawer}
        setRoundValues={setRoundValues}
        roundValues={roundValues}
        atsParam={params?.roleId}
        candidateCall={''}
        setOpenDrawer={setOpenDrawer}
        scheduleTrue={scheduleTrue}
        setScheduleTrue={setScheduleTrue}
        isEditingForm={isEditingForm}
        setIsEditingForm={setIsEditingForm}
        setSaveEnable={setSaveEnable}
        rolesMetrics={rolesMetrics}
        getRoleMetrics={getRoleMetrics}
        fetchRounds={fetchRounds}
        isSubmitting={isSubmitting}
        setIsSubmitting={setIsSubmitting}
      />
    )
  }
  const handleExportType = value => {
    if (exportType == value) {
      setExportType('')
    } else {
      setExportType(value)
    }
  }
  const handleChangeDrawer = async()=>{
      setSave(true)
      setFormSave(true)
      // setOpenDrawer(false)
      setIsEditingForm(false)
      removeParams()
  }
  const handleExportClick = async () => {
    setExportLoading(true)
    try {
      // Export must honour the candidates currently in view — i.e. the full set
      // matching the active stage/filter/search — not an explicit checkbox
      // selection. Resolve that filtered set via the same list source the table
      // uses.
      const studentIds = await fetchBulkStudentIds()

      let payload = {
        downloadList: selectedKeys.map(item => item.title),
        stage: stage == 'all_candidates' || stage == null ? 'all' : stage,
        studentIds,
      }

      if (exportType === 'xlsx') {
        try {
          const blob = await atsExportCandidate(
            params.roleId,
            corporateData.id,
            exportType,
            payload
          )
          const url = window.URL.createObjectURL(new Blob([blob]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'Role.xlsx')
          document.body.appendChild(link)
          link.click()
          link.parentNode.removeChild(link)
          setExportLoading(false)
          handleTransferClick(false)
        } catch (error) {
          setExportLoading(false)
          ErrorMessage(error)
        }
      } else if (exportType === 'googlesheet') {
        try {
          const response = await atsExportCandidate(
            params.roleId,
            corporateData.id,
            exportType,
            payload
          )
          window.open(response?.data?.url, '_blank')
          setExportLoading(false)
          handleTransferClick(false)
        } catch (error) {
          setExportLoading(false)
          ErrorMessage(error)
        }
      } else {
        try {
          const blob = await atsExportCandidate(
            params.roleId,
            corporateData.id,
            exportType,
            payload
          )
          const url = window.URL.createObjectURL(
            new Blob([blob], { type: 'text/csv' })
          )
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'Export.csv')

          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          handleTransferClick(false)

          setExportLoading(false)
        } catch (error) {
          setExportLoading(false)
          ErrorMessage(error)
        }
      }
    } catch (error) {
      ErrorMessage(error)
    }
  }

  const footer = () => {
    const rounds =  rolesMetrics[0]?.rounds || [];
    let disable = false
    if (rounds.length > 0) {
      const lastRound = rounds[rounds.length - 1] // last element
      const lastCount = lastRound.count 
      if(lastCount > 0){
        disable=true
      }
    }
    return (
      <FooterFlex right>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            setOpenDrawer(false)
            removeParams()
            setIsEditingForm(false)
          }}
        />
        <Button.Primary
          // htmlType="submit"
          form="bulkUpload"
          text="Save"
          icon={!save}
          disabled={saveEnable || isEditingForm || disable}
          onClick={handleChangeDrawer}
        />
      </FooterFlex>
    )
  }
  const dropdownContainer = React.useRef(null)
  return (
    <SectionWrapper>
      <PaddedDiv column>
        <TopHeader row spaceBetween alignCenter ref={tableRef}>
          <LeftSection centerVertically>
            <Link to={`/jobRoles/jobPreview/${params?.roleId}?selectedCategory=PLACEMENT&q=APPLIED&tab=1`}>
              <LeftArrow />
            </Link>
            <SectionName column>
              <RoutePath
                fromArr={paths}
                on={
                  rolesMetrics[0]?.roleName?.charAt(0)?.toUpperCase() +
                  rolesMetrics[0]?.roleName?.slice(1)
                }
                path="/roles"
              />
              <DropDown
                overlay={roleMenu(onRoleChange, driveRolesMetrics)}
                trigger={
                  checkType === 'EXTERNAL_ASSESMENT' && JSON.parse(isUpload)
                    ? ''
                    : ['click']
                }
                getPopupContainer={() => dropdownContainer.current}
              >
                <RoleNameFlex ref={dropdownContainer}>
                  <RoleNameDiv style={{ whiteSpace: 'nowrap' }}>
                    {rolesMetrics[0]?.roleName}
                  </RoleNameDiv>
                  <div>
                    <DownArrowSolid />
                  </div>

                  {JSON.parse(isUpload) &&
                    checkType === 'EXTERNAL_ASSESMENT' &&
                    JSON.parse(isBack) !== true && (
                      <EmptyElement
                        style={{
                          color: 'blue',
                          fontSize: '13px',
                          justifyContent: 'center',
                          alignItems: 'center',
                          display: 'flex',
                          fontWeight: 400,
                          textDecoration: 'underline',
                          marginLeft: '15px',
                        }}
                        onClick={e => onClickLink(e, 'previous')}
                      >
                        Go to Active Page
                      </EmptyElement>
                    )}
                  {JSON.parse(isUpload) &&
                    checkType === 'EXTERNAL_ASSESMENT' &&
                    JSON.parse(isBack) && (
                      <EmptyElement
                        style={{
                          color: 'blue',
                          fontSize: '13px',
                          justifyContent: 'center',
                          alignItems: 'center',
                          display: 'flex',
                          fontWeight: 400,
                          textDecoration: 'underline',
                          marginLeft: '15px',
                        }}
                        onClick={e => onClickLink(e, 'score')}
                      >
                        Go to Score Page
                      </EmptyElement>
                    )}
                </RoleNameFlex>
              </DropDown>
            </SectionName>
          </LeftSection>
          {driveData?.corporateStatus === 'CANCELLED' ? null : (
            <TopEndFlex alignCenter>
              {stage !== 'offer' && stage === 'all_candidates' && (
              <Button.Primary
                style={{ marginRight: '10px',
                  cursor: isAllCandidates ? 'pointer' : 'not-allowed',
                  opacity: isAllCandidates ? 1 : 1,
               }}
                height={'38px'}
                text={'Add Evaluation process'}
                // disabled={!isAllCandidates}
                onClick={() => {
                  if (!isAllCandidates) return;
                  setOpenDrawer(true)
                }}
              />
              )}
              {driveData?.corporateStatus === 'CANCELLED' ? null : (
                        <div
              style={{
                cursor: isDisabled ? 'not-allowed' : 'pointer',
                opacity: isDisabled ? 0.5 : 1,
                marginRight: '10px',
              }}
            >
              <div
                style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                onClick={() => {
                  if (isDisabled) return;
                  handleTransferClick(true);
                }}
              >
                <AtsExportIcon
                  style={{
                    cursor: 'pointer',
                    opacity: isDisabled ? 0.5 : 1,
                  }}
                />
              </div>
            </div>
              )}

              {selectedRound !== 'all_candidates' &&
                status?.includes('ACTIVE') &&
                subEvents?.includes('BULK ACTION') &&
                stage === 'offer' &&
                selectedCandidateId?.length > 0 &&
                // Only show bulk action if all selected candidates have "Intent to Offer" status (SHORTLISTED)
                selectedCandidate?.every(candidate => candidate?.offerStatus === 'SHORTLISTED') && (
                  <BulkUploadDiv>
                    <Button.Primary
                      onClick={() => {
                        setBulkAction(true)
                      }}
                      width="117px"
                      height="38px"
                      disable={selectedCandidateId?.length <= 0}
                      text="Bulk Action"
                    />
                  </BulkUploadDiv>
                )}
              {subEvents?.includes('DOWNLOAD/UPLOAD') && (
                <div style={{ marginRight: '10px' }}>
                <DownlaodUpload
                  triggerLabel={selectedRound === 'all_candidates' ? 'Bulk Upload' : undefined}
                  nextRoundData={nextRoundData}
                  setNextRoundData={setNextRoundData}
                  nextRoundFunction={nextRoundFunction}
                  rounds={rounds}
                  driveId={params?.driveId}
                  noNeedRole={true}
                  roleId={params?.roleId}
                  getCandidateList={getCandidateList}
                  getGDList={getGDList}
                  fileUpload={fileUpload}
                  stage={stage}
                  checkType={checkType}
                  setSearchParams={setSearchParams}
                  rolesMetrics={rolesMetrics?.[0]?.rounds?.find(
                    item => item.roundName === selectedRound
                  )}
                  allRounds={rolesMetrics?.[0]?.rounds}
                  downloadTemplate={downloadTemplate}
                  uploadShorlistResult={uploadShorlistResult}
                  selectedRound={popSelectedRound}
                  setSelectedRound={setPopSelectedRound}
                  updateResolveConflictCandidates={updateResolveConflictCandidates}
                  getConflictCandidates={getConflictCandidates}
                  roundId={roundId}
                  setErrorMessage={ErrorMessage}
                  setIsAllSelected={setIsAllSelected}
                  setSelectedIds={setSelectedIds}
                  setWholeSelect={setWholeSelect}
                  setConflictData={setConflictData}
                  assessment={assessment}
                />
                </div>
              )}
              {selectedRound === 'all_candidates' && (
                <Button.Primary
                  text="Add Candidates"
                  height="38px"
                  onClick={() => setInviteDrawerOpen(true)}
                />
              )}
            </TopEndFlex>
          )}
        </TopHeader>
        <Metrics
          rolesMetrics={rolesMetrics}
          selectedRound={selectedRound}
          setSelectedRound={setSelectedRound}
          setSearchParams={setSearchParams}
          setCurrentPage={setCurrentPage}
          setSelectedCandidateId={setSelectedCandidateId}
          setSelectedCandidate={setSelectedCandidate}
          setIsAllSelected={setIsAllSelected}
          setCurrentTab={setCurrentTab}
          setStatus={setStatus}
          setFilterStatus={setFilterStatus}
          setType={setType}
          setCurrentScoreTab={setCurrentScoreTab}
          setScoreStatus={setScoreStatus}
          setSearchValue={setSearchValue}
          setSearchScoreValue={setSearchScoreValue}
          setCurrentScorePage={setCurrentScorePage}
          setPanelData={setPanelData}
          setPanelValue={setPanelValue}
          setLastPanelId={setLastPanelId}
          setScorePayload={setScorePayload}
          setTabValue={setTabValue}
          isDisabled={isLoading}
          getConflictCandidates={getConflictCandidates}
          conflictData={conflictData}
          setConflictData={setConflictData}
          roleId={params?.roleId}
        />

        {JSON.parse(isUpload) &&
          checkType === 'EXTERNAL_ASSESMENT' &&
          !JSON.parse(isBack) && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'end',
                position: 'relative',
                right: '60px',
              }}
            >
              <Button.Primary
                width="117px"
                height="38px"
                onClick={() => {
                  onDrawerOpen()
                }}
                disable={selectedIds?.length < 1}
                text="Shortlist"
              />
            </div>
          )}
        {JSON.parse(isUpload) &&
        checkType === 'EXTERNAL_ASSESMENT' &&
        !JSON.parse(isBack) ? (
          <div style={{ display: 'flex' }}>
            <StyledTab
              onChange={onScoreTabChange}
              width={'100%'}
              activeKey={currentScoreTab}
              defaultActiveKey={currentScoreTab}
            >
              {scoreTabList?.map(data => {
                return (
                  <TabPane
                    tab={
                      <Fragment>
                        {data?.tabName}
                        <CandidatesSpan>
                          {getZeroBeforeInt(data?.count)}
                        </CandidatesSpan>
                      </Fragment>
                    }
                    key={data?.key}
                  >
                    <ExternalDriveTable
                      count={count}
                      filter={filter}
                      setFilter={setFilter}
                      isLoading={isLoading}
                      searchScoreValue={searchScoreValue}
                      setSearchScoreValue={setSearchScoreValue}
                      currentScorePage={currentScorePage}
                      setCurrentScorePage={setCurrentScorePage}
                      setScoreSortBy={setSortScoreBy}
                      candidateScoreDeatils={candidateScoreDeatils}
                      setSelectedIds={setSelectedIds}
                      topicsPayload={topicsPayload}
                      setTopicsPayload={setTopicsPayload}
                      onShortlistButtonClick={onShortlistButtonClick}
                      getTopicsList={getTopicsList}
                      assessmentId={assessmentId}
                      postPassingScore={postPassingScore}
                      getCandidateScore={getCandidateScore}
                      setSearchName={setSearchName}
                      searchName={searchName}
                      driveData={driveData}
                      scheduleDrawer={scheduleDrawer}
                      setScheduleDrawer={setScheduleDrawer}
                      createSlotDrawer={createSlotDrawer}
                      setCreateSlotDrawer={setCreateSlotDrawer}
                      candidateDetails={candidateDetails}
                      rolesMetrics={rolesMetrics}
                      candidateInterviewDetails={candidateInterviewDetails}
                      candidateInfoData={candidateInfoData}
                      updateInterviewStatus={updateInterviewStatus}
                      driveId={params?.expcandidatesId}
                      roleId={params?.roleId}
                      drive={params?.driveId}
                      getCandidateList={getCandidateList}
                      selectedRoundType={selectedRoundType}
                      loading={isLoading}
                      getRoleMetrics={getRoleMetrics}
                      setSelectedCandidate={setSelectedCandidate}
                      setSelectedCandidateId={setSelectedCandidateId}
                      getSingleCandidateInterviewDetails={
                        getSingleCandidateInterviewDetails
                      }
                      setReleaseOffer={setReleaseOffer}
                      isUpload={isUpload}
                      getCandidateDetails={getCandidateDetails}
                      isVisible={
                        scoreStatus == 'INVITED,STARTED,COMPLETED,ABSENT'
                      }
                      subEvents={subEvents}
                      selectedIds={selectedIds}
                      setIsMenuOpen={setIsMenuOpen}
                      isMenuOpen={isMenuOpen}
                    />
                  </TabPane>
                )
              })}
            </StyledTab>
            {}
          </div>
        ) : stage === 'all_candidates' || stage === null ? (
          <StyledTab
            disabled={isLoading}
            onChange={onTabChange}
            width={'100%'}
            activeKey={currentTab}
            defaultActiveKey={'APPLIED_TAB'}
            height={true}
          >
            {tabDeatils?.map((data) => {
              return (
                <TabPane
                  disabled={isLoading}
                  tab={
                    <Fragment>
                      {data?.tabName}
                      <CandidatesSpan>
                        {getZeroBeforeInt(data?.count)}
                      </CandidatesSpan>
                    </Fragment>
                  }
                  key={data?.key}
                >
                  {data?.key === 'INVITED_TAB' ? (
                    <InvitedCandidatesTable
                      key={inviteTableRefresh}
                      roleId={params?.roleId}
                    />
                  ) : (
                    <IndividualDriveTable
                      nextRoundData={nextRoundData}
                      setNextRoundData={setNextRoundData}
                      nextRoundFunction={nextRoundFunction}
                      fetchBulkStudentIds={fetchBulkStudentIds}
                      rounds={rounds}
                      roundName={type?.round}
                      selectedCandidate={selectedCandidate}
                      getPanelList={getPanelList}
                      getNewIndividualDriveStatus={getNewIndividualDriveStatus}
                      setScorePayload={setScorePayload}
                      newDriveStatusData={newDriveStatusData}
                      newDriveScoreData={newDriveScoreData}
                      filter={filter}
                      setFilter={setFilter}
                      stages={stage}
                      singleRoleData={singleRoleData}
                      driveData={driveData}
                      scheduleDrawer={scheduleDrawer}
                      setScheduleDrawer={setScheduleDrawer}
                      candidateDeatils={candidateDeatils}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      setSearchValue={setSearchValue}
                      searchValue={searchValue}
                      setSortBy={setSortBy}
                      isLoading={isLoading}
                      candidateRating={candidateRating}
                      setCandidateRating={setCandidateRating}
                      interviewRound={interviewRound}
                      setInterviewRound={setInterviewRound}
                      getCandidateList={getCandidateList}
                      rolesMetrics={rolesMetrics}
                      degreeList={degreeList}
                      searchParams={searchParams}
                      setSearchParams={setSearchParams}
                      checkedKeys={checkedKeys}
                      setCheckedKeys={setCheckedKeys}
                      checkedIds={checkedIds}
                      setCheckedIds={setCheckedIds}
                      setSelectedCandidateId={setSelectedCandidateId}
                      setSelectedCandidate={setSelectedCandidate}
                      collegeList={collegeList}
                      college={college}
                      setCollege={setCollege}
                      setCollegeSearch={setCollegeSearch}
                      getCandidateDetails={getCandidateDetails}
                      candidateDetails={candidateDetails}
                      getSingleCandidateInterviewDetails={
                        getSingleCandidateInterviewDetails
                      }
                      driveId={params?.driveId}
                      roleId={params?.roleId}
                      candidateInterviewDetails={candidateInterviewDetails}
                      updateInterviewStatus={updateInterviewStatus}
                      selectedRoundType={selectedRoundType}
                      getGroupCandidateList={getGroupCandidateList}
                      groupList={groupList}
                      groupCandidateList={groupCandidateList}
                      status={status}
                      stage={stage}
                      candidateInfoData={candidateInfoData}
                      setCandidateInfoData={setCandidateInfoData}
                      setStatus={setStatus}
                      filterStatus={filterStatus}
                      setFilterStatus={setFilterStatus}
                      setIsAllSelected={setIsAllSelected}
                      isAllSelected={isAllSelected}
                      getRoleMetrics={getRoleMetrics}
                      selectedCandidateId={selectedCandidateId}
                      setReleaseOffer={setReleaseOffer}
                      currentTab={currentTab}
                      getNewDriveFreshersList={getNewDriveFreshersList}
                      newFreshersListData={newFreshersListData}
                      panelValue={panelValue}
                      setPanelValue={setPanelValue}
                      setPanelData={setPanelData}
                      panelData={panelData}
                      getDriveRoleMetrics={getDriveRoleMetrics}
                      selectedFilterValue={selectedFilterValue}
                      setSelectedFilterValue={setSelectedFilterValue}
                      filterValues={filterValues}
                      setFilterValues={setFilterValues}
                      setBulkDownload={setBulkDownload}
                      setStudentListId={setStudentListId}
                      setActionDrawer={setActionDrawer}
                      getRounds={getRounds}
                      getStatus={getStatus}
                      getYear={getYear}
                      setWholeSelect={setWholeSelect}
                      wholeSelect={wholeSelect}
                      getCollegeListForFilter={getCollegeListForFilter}
                      getSkillForFilter={getSkillForFilter}
                      getQuestionForFilter={getQuestionForFilter}
                      getCustomQuestionFilterOptions={getCustomQuestionFilterOptions}
                      getWorkExperienceForFilter={getWorkExperienceForFilter}
                      getLocationForFilter={getLocationForFilter}
                      getDegreeForFilter={getDegreeForFilter}
                      getNewDriveScore={getNewDriveScore}
                      popSelectedRound={popSelectedRound}
                      setPopSelectedRound={setPopSelectedRound}
                      getConflictCandidates={getConflictCandidates}
                      conflictData={conflictData}
                      setConflictData={setConflictData}
                      setISLoading={setISLoading}
                      updateResolveConflictCandidates={updateResolveConflictCandidates}
                    />
                  )}
                </TabPane>
              )
            })}
          </StyledTab>
        ) : (
          <StyledTab
            disabled={isLoading}
            onChange={onTabChange}
            width={'100%'}
            activeKey={currentTab}
            defaultActiveKey={currentTab}
            height={stage === 'all_candidates'}
          >
            {tabDeatils?.map((data, tabIndex) => {
              return (
                <TabPane
                  disabled={isLoading}
                  tab={
                    <Fragment>
                      {data?.tabName}
                      <CandidatesSpan>
                        {getZeroBeforeInt(data?.count)}
                      </CandidatesSpan>
                    </Fragment>
                  }
                  key={data?.key}
                >
                  <IndividualDriveTable
                    nextRoundData={nextRoundData}
                    setNextRoundData={setNextRoundData}
                    nextRoundFunction={nextRoundFunction}
                    fetchBulkStudentIds={fetchBulkStudentIds}
                    rounds={rounds}
                    tabIndex={tabIndex}
                    roundName={type?.round}
                    setPanelData={setPanelData}
                    panelData={panelData}
                    panelValue={panelValue}
                    setPanelValue={setPanelValue}
                    selectedCandidate={selectedCandidate}
                    getPanelList={getPanelList}
                    getNewIndividualDriveStatus={getNewIndividualDriveStatus}
                    setScorePayload={setScorePayload}
                    newDriveStatusData={newDriveStatusData}
                    newDriveScoreData={newDriveScoreData}
                    getNewDriveFreshersList={getNewDriveFreshersList}
                    newFreshersListData={newFreshersListData}
                    filter={filter}
                    setFilter={setFilter}
                    stages={stage}
                    singleRoleData={singleRoleData}
                    driveData={driveData}
                    scheduleDrawer={scheduleDrawer}
                    setScheduleDrawer={setScheduleDrawer}
                    candidateDeatils={candidateDeatils}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    setSearchValue={setSearchValue}
                    searchValue={searchValue}
                    setSortBy={setSortBy}
                    isLoading={isLoading}
                    candidateRating={candidateRating}
                    setCandidateRating={setCandidateRating}
                    interviewRound={interviewRound}
                    setInterviewRound={setInterviewRound}
                    getCandidateList={getCandidateList}
                    rolesMetrics={rolesMetrics}
                    degreeList={degreeList}
                    searchParams={searchParams}
                    setSearchParams={setSearchParams}
                    checkedKeys={checkedKeys}
                    setCheckedKeys={setCheckedKeys}
                    checkedIds={checkedIds}
                    setCheckedIds={setCheckedIds}
                    setSelectedCandidateId={setSelectedCandidateId}
                    setSelectedCandidate={setSelectedCandidate}
                    collegeList={collegeList}
                    college={college}
                    setCollege={setCollege}
                    setCollegeSearch={setCollegeSearch}
                    getCandidateDetails={getCandidateDetails}
                    candidateDetails={candidateDetails}
                    getSingleCandidateInterviewDetails={
                      getSingleCandidateInterviewDetails
                    }
                    driveId={params?.driveId}
                    roleId={params?.roleId}
                    candidateInterviewDetails={candidateInterviewDetails}
                    updateInterviewStatus={updateInterviewStatus}
                    selectedRoundType={selectedRoundType}
                    getGroupCandidateList={getGroupCandidateList}
                    groupList={groupList}
                    groupCandidateList={groupCandidateList}
                    status={status}
                    stage={stage}
                    candidateInfoData={candidateInfoData}
                    setCandidateInfoData={setCandidateInfoData}
                    setStatus={setStatus}
                    filterStatus={filterStatus}
                    setFilterStatus={setFilterStatus}
                    getRoleMetrics={getRoleMetrics}
                    selectedCandidateId={selectedCandidateId}
                    setReleaseOffer={setReleaseOffer}
                    currentTab={currentTab}
                    subEvents={subEvents}
                    getDriveRoleMetrics={getDriveRoleMetrics}
                    setIsAllSelected={setIsAllSelected}
                    isAllSelected={isAllSelected}
                    selectedTab={data}
                    setWholeSelect={setWholeSelect}
                    wholeSelect={wholeSelect}
                    selectedFilterValue={selectedFilterValue}
                    setSelectedFilterValue={setSelectedFilterValue}
                    filterValues={filterValues}
                    setFilterValues={setFilterValues}
                    setBulkDownload={setBulkDownload}
                    setStudentListId={setStudentListId}
                    setActionDrawer={setActionDrawer}
                    getRounds={getRounds}
                    getStatus={getStatus}
                    getYear={getYear}
                    getCollegeListForFilter={getCollegeListForFilter}
                    getSkillForFilter={getSkillForFilter}
                    getQuestionForFilter={getQuestionForFilter}
                    getCustomQuestionFilterOptions={getCustomQuestionFilterOptions}
                    getWorkExperienceForFilter={getWorkExperienceForFilter}
                    getLocationForFilter={getLocationForFilter}
                    getDegreeForFilter={getDegreeForFilter}
                    getNewDriveScore={getNewDriveScore}
                    popSelectedRound={popSelectedRound}
                    setPopSelectedRound={setPopSelectedRound}
                    getConflictCandidates={getConflictCandidates}
                    conflictData={conflictData}
                    setConflictData={setConflictData}
                    setISLoading={setISLoading}
                    updateResolveConflictCandidates={updateResolveConflictCandidates}
                  />
                </TabPane>
              )
            })}
          </StyledTab>
        )}
      </PaddedDiv>

      <BulkActionDrawer
        bulkAction={bulkAction}
        setBulkAction={setBulkAction}
        scheduleDrawer={scheduleDrawer}
        setScheduleDrawer={setScheduleDrawer}
        releaseOffer={releaseOffer}
        setReleaseOffer={setReleaseOffer}
        selectedCandidateId={selectedCandidateId}
        selectedCandidate={selectedCandidate}
        rolesMetrics={rolesMetrics}
        createInterview={createInterview}
        driveId={params?.driveId}
        roleId={params?.roleId}
        driveInterViewerList={driveInterViewerList}
        getDriveInterviewerList={getDriveInterviewerList}
        selectedRound={selectedRound}
        driveData={driveData}
        selectedRoundType={selectedRoundType}
        candidateDeatils={candidateDeatils}
        candidateInfoData={candidateInfoData}
        getCandidateList={getCandidateList}
        getRoleMetrics={getRoleMetrics}
        setSelectedCandidateId={setSelectedCandidateId}
        setSelectedCandidate={setSelectedCandidate}
        getCities={getCities}
        cityList={cityList}
        releaseOfferAPI={releaseOfferAPI}
        stage={stage}
        singleRoleData={singleRoleData}
        tabNames={tabNames}
        status={status}
        getNewDriveFreshersList={getNewDriveFreshersList}
        lastPanelId={lastPanelId}
        getDriveRoleMetrics={getDriveRoleMetrics}
        isAllSelected={isAllSelected}
        setIsAllSelected={setIsAllSelected}
      />
      <ShortListDrawer
        selectedIds={selectedIds}
        setShortListDrawer={setShortListDrawer}
        shortListDrawer={shortListDrawer}
        onShortlistButtonClick={onShortlistButtonClick}
      />
      <Drawer
        width="40%"
        title={'Add Evaluation Process'}
        placement="right"
        closable={true}
        visible={openDrawer}
        content={content()}
        footer={footer()}
        onClose={() => {
          setOpenDrawer(false)
          removeParams()
          setIsEditingForm(false)
        }}
      />

      <ActionRoleDrawer
        description="Are you sure you want to download all selected resumes?"
        showDrawer={actionDrawer}
        setShowDrawer={setActionDrawer}
        onApprove={handleApprove}
        onCloseClick={handleClose}
        closeText="No"
        YesText="Yes"
      />
      <SuccessModal
        description={
          <div>
            Your request is being processed. Please check your email inbox
            shortly for the download link.
          </div>
        }
        Icon={SuccessIcon}
        showDrawer={showSuccessPopup}
        setShowDrawer={setShowSuccessPopup}
        onCloseClick={closePopup}
      />
      <ExportTransfer
        open={transfer}
        handleClose={handleTransferClick}
        data={exportData}
        columns={columns}
        disabled={disabled}
        targetKeys={targetKeys}
        setTargetKeys={setTargetKeys}
        setSelectedKeys={setSelectedKeys}
        exportType={exportType}
        handleExportType={handleExportType}
        handleExportClick={handleExportClick}
        exportLoading={exportLoading}
        setExportLoading={setExportLoading}
        setDisabled={setDisabled}
      />
      <UploadInviteDrawer
        visible={inviteDrawerOpen}
        setVisible={setInviteDrawerOpen}
        roleId={params?.roleId}
        driveId={params?.driveId}
        setIsDrawer={() => {}}
        setInviteTableRefresh={setInviteTableRefresh}
        setInvitedCount={setInvitedCount}
      />
    </SectionWrapper>

  )
}

export default ViewIndividualDrive

